import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Col, Row, Tooltip } from "antd";
import HoursByDocumentGraph from "./HoursByDocumentGraph";
import { sortByAmount, sortByAlpha } from "./utils";
import SalesRepAndDocumentGraph from "./salesRepAndDocumentGraph";
import TotalHours from "./totalHours";
import { ReactComponent as SortAlphabetically } from "../../assets/sortAlphabetically.svg";
import { ReactComponent as SortByAmount } from "../../assets/sortByAmount.svg";
import SpinnerComponent from "../../components/spinner";

const DocumentControlReporting = () => {
  const [salesUserDocumentdata, setSalesUserDocumentData] = useState([]);
  const [sortOrder, setSortOrder] = useState({
    alphaSort: false,
    sortByAmount: false,
  });
  const { sales_user_document, fetchingLoading, colorsObjArr, graphData } = useSelector(
    (state) => state.documentControlReducer
  );

  useEffect(() => {
    setSalesUserDocumentData(sales_user_document);
  }, [sales_user_document]);

  const handleSortClientByAlpha = () => {
    setSortOrder((prev) => ({
      ...sortOrder,
      alphaSort: !prev.alphaSort,
    }));
    let res = sortByAlpha(salesUserDocumentdata, sortOrder.alphaSort);
    setSalesUserDocumentData(res);
  };

  const handleSortClientByAmount = () => {
    setSortOrder((prev) => ({
      ...sortOrder,
      sortByAmount: !prev.sortByAmount,
    }));
    let res = sortByAmount(salesUserDocumentdata, sortOrder.sortByAmount);
    setSalesUserDocumentData(res);
  };

  return (
    <Row className="production-manager-parent-row">
      <Col span={24} className="heading-col">
        <Row>
          <Col>
            <span className="heading-span" style={{ color: "#0d2843" }}>
              DOCUMENT CONTROL REPORTING
            </span>
          </Col>
        </Row>
      </Col>
      <Col span={24} className="graph-section">
        {fetchingLoading ? (
          <div className="spinner-div">
            <SpinnerComponent fontSize={50} />
          </div>
        ) : (
          <Row gutter={[40, 40]}>
            <Col md={24} lg={24} xl={24} xxl={12}>
              <div className="production-by-client-div">
                <span className="graph-text-span" style={{ color: "#0d2843" }}>
                Total vs Completed by Document Type
                </span>
                <Tooltip
                  arrowPointAtCenter
                  placement="top"
                  title="Sort by Alphabetically"
                >
                  <SortAlphabetically
                    className="sort-icons"
                    onClick={handleSortClientByAlpha}
                  />
                </Tooltip>
                <Tooltip
                  arrowPointAtCenter
                  placement="top"
                  title={`Sort by Amount`}
                >
                  <SortByAmount
                    className="sort-icons"
                    onClick={handleSortClientByAmount}
                  />
                </Tooltip>
              </div>
              <div className="graph-label-with-text">
                <div
                  className="actual-div"
                  style={{ display: "block", fontWeight: 600 }}
                >
                  {/* Format: */}
                </div>
                <Row gutter={[10, 5]} justify="start" align="top">
                  {colorsObjArr.map((el) => {
                    const { key, color } = el;
                    return (
                      <Col key={key}>
                        <div className="actual-div">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: color,
                            }}
                          ></span>
                          {key}
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <SalesRepAndDocumentGraph />
            </Col>
            <Col md={24} lg={24} xl={20} xxl={9}>
              <span className="graph-text-span" style={{ color: "#0d2843" }}>
                Total vs Completed</span>
              <HoursByDocumentGraph />
              <TotalHours />
            </Col>
            {/* <Col md={16} lg={12} xl={16} xxl={3}>
              <div style={{ textAlign: "center" }}>
                <span className="graph-text-span">Total Hours</span>
              </div>
            </Col> */}
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default DocumentControlReporting;
